'use client';

import React from 'react';
import NoResultFound from 'components/commercetools-ui/organisms/no-result';

const NoResultFoundTastic = () => {
  return <NoResultFound />;
};

export default NoResultFoundTastic;